export const GYM_AMENITIES = [
  "Swimming Pool",
  "Sauna",
  "Parking",
  "Locker Rooms",
  "Café",
  "Yoga Studio",
  "Cardio Zone",
  "Free WiFi",
];
